import React, { FC } from 'react';
import useSetupKeepState from '../../global/hooks/useSetupKeepState';
import CustomersMainContent from './components/CustomersMainContent/CustomersMainContent';

const Customers: FC = () => {
  const key = useSetupKeepState();
  if (key === 'replaceState') {
    return null;
  }
  return <CustomersMainContent key={key} />;
};

export default Customers;
